import React from 'react';
import {
  IconCalendar,
  IconCreditCard,
  IconMegaphone,
  IconOffice2,
  IconReceipt,
  IconSafeBox,
} from '../SystemIcon/Icons';
import { ProductFeatureIconName } from './ProductFeatureIconName';
import {
  IconAccount,
  IconAccountActivity,
  IconAccountPayable,
  IconAccountReceivable,
  IconAddProduct,
  IconApiInquiry,
  IconApiTransactionData,
  IconBank,
  IconBankAccount,
  IconBillerApi,
  IconBridgingReport,
  IconBulkDisbursement,
  IconCashDelivery,
  IconCashDeposit,
  IconCashDepositMachine,
  IconCashPickup,
  IconCashWithdrawal,
  IconClaimFund,
  IconCustomerData,
  IconDepositWithdrawalApi,
  IconDeveloperOption,
  IconDisbursementApi,
  IconDocumentation,
  IconEWalletApi,
  IconElectronicDataCapture,
  IconExpenseAnalytics,
  IconHome,
  IconInternationalTransfer,
  IconInvoice,
  IconMoreNonTx,
  IconMoreService,
  IconMultiAccount,
  IconMultiAccount2,
  IconNotifications,
  IconPaymentLink,
  IconPaymentLink2,
  IconPaymentRouting,
  IconReimbursement,
  IconSetting,
  IconTransactionCategory,
  IconTransactionReport,
  IconUserManagement,
  IconVendorData,
  IconVirtualAccount,
  IconVirtualCard,
} from './ProductFeatureIcons';

/// IMPORTANT!! If you want tou add an/some icon/s you should insert it alphabetically either in import or in code bellow
const RenderIcons = (name: ProductFeatureIconName, fill: string) => {
  switch (name) {
    case 'account-activity':
      return <IconAccountActivity fill={fill} />;
    case 'accounts':
      return <IconAccount fill={fill} />;
    case 'auto-withdrawal':
      return <IconSafeBox fill={fill} />;
    case 'business-banking':
      return <IconAccountPayable fill={fill} />;
    case 'business-profile':
      return <IconOffice2 fill={fill} />;
    case 'bulk-receipt':
      return <IconReceipt fill={fill} />;
    case 'account-receivable/invoice':
      return <IconAccountReceivable fill={fill} />;
    case 'add-product':
      return <IconAddProduct fill={fill} />;
    case 'api-hit-report/api-inquiry':
      return <IconApiInquiry fill={fill} />;
    case 'api-hit-report/api-transactions-data':
      return <IconApiTransactionData fill={fill} />;
    case 'bank':
      return <IconBank fill={fill} />;
    case 'bank-account':
      return <IconBankAccount fill={fill} />;
    case 'disbursement/api-biller':
      return <IconBillerApi fill={fill} />;
    case 'bridging-report/v2':
    case 'bridging-report':
      return <IconBridgingReport fill={fill} />;
    case 'disbursement/bulk':
      return <IconBulkDisbursement fill={fill} />;
    case 'request-money/offline-cash-deposit':
      return <IconCashDeposit fill={fill} />;
    case 'request-money/cash-delivery':
      return <IconCashDelivery fill={fill} />;
    case 'request-money/cash-deposit-machine':
      return <IconCashDepositMachine fill={fill} />;
    case 'disbursement/offline-cash-withdrawal':
      return <IconCashWithdrawal fill={fill} />;
    case 'disbursement/claim-fund':
      return <IconClaimFund fill={fill} />;
    case 'account-receivable/customer-management':
      return <IconCustomerData fill={fill} />;
    case 'disbursement/api-offline/cash-out':
    case 'request-money/api-offline/cash-in':
      return <IconDepositWithdrawalApi fill={fill} />;
    case 'disbursement/api-disburse':
      return <IconDisbursementApi fill={fill} />;
    case 'book':
    case 'help-documentation':
      return <IconDocumentation fill={fill} />;
    case 'request-money/edc':
      return <IconElectronicDataCapture fill={fill} />;
    case 'request-money/e-wallet':
      return <IconEWalletApi fill={fill} />;
    case 'expense-analytic':
      return <IconExpenseAnalytics fill={fill} />;
    case 'home':
      return <IconHome fill={fill} />;
    case 'cashPickup':
      return <IconCashPickup fill={fill} />;
    case 'credit-card':
      return <IconCreditCard fill={fill} />;
    case 'notifications':
      return <IconNotifications fill={fill} />;
    case 'notifications-2':
      return <IconMegaphone fill={fill} />;
    case 'disbursement/international-remittance':
      return <IconInternationalTransfer fill={fill} />;
    case 'our-services':
    case 'integration':
      return <IconMoreService fill={fill} />;
    case 'invoice':
      return <IconInvoice fill={fill} />;
    case 'language-and-timezone':
      return <IconCalendar fill={fill} />;
    case 'more-non-tx':
      return <IconMoreNonTx fill={fill} />;
    case 'multi-entity':
      return <IconMultiAccount fill={fill} />;
    case 'multi-entity-2':
      return <IconMultiAccount2 fill={fill} />;
    case 'request-money/payment-checkout':
      return <IconPaymentLink fill={fill} />;
    case 'payment-link-2':
      return <IconPaymentLink2 fill={fill} />;
    case 'request-money/payment-routing':
      return <IconPaymentRouting fill={fill} />;
    case 'reimburse':
    case 'expense-management/reimbursement':
      return <IconReimbursement fill={fill} />;
    case 'settings':
    case 'dev-config':
      return <IconSetting fill={fill} />;
    case 'developer-option':
      return <IconDeveloperOption fill={fill} />;
    case 'transaction-report':
      return <IconTransactionReport fill={fill} />;
    case 'transaction-category':
      return <IconTransactionCategory fill={fill} />;
    case 'user-management':
      return <IconUserManagement fill={fill} />;
    case 'vendor':
      return <IconVendorData fill={fill} />;
    case 'virtual-account':
      return <IconVirtualAccount fill={fill} />;
    case 'expense-management/corporate-card':
      return <IconVirtualCard fill={fill} />;
    case 'expense-management/bridging-fund':
      return <IconBridgingReport fill={fill} />;
    default:
      return <span />;
  }
};

export default RenderIcons;
